/**
 * @type {function} getFieldTemplate
 * @param {string} placeholder
 * @return {{type: string, required: string[], properties: {selector: {disallowEmptyString: boolean, type: string}, placeholder: {default, type: string}}}}
 */
export const getFieldTemplate = (placeholder) => {
	return {
		type: "object",
		required: ["selector"],
		properties: {
			selector: { type: "string", disallowEmptyString: false },
			placeholder: { type: "string", default: placeholder },
			initialValue: { type: "string" },
			ariaLabel: { type: "string", disallowEmptyString: true }
		},
		additionalProperties: false
	};
};

/**
 * @type {function} getSubmitTemplate
 * @return {{type: string, required: string[], properties: {selector: {disallowEmptyString: boolean, type: string}}}}
 */
export const getSubmitTemplate = () => {
	return {
		type: "object",
		required: ["selector"],
		properties: {
			selector: { type: "string", disallowEmptyString: false }
			// callback: { typeof: "function" }
		}
	};
};
